import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4" }
const _hoisted_2 = {
  class: "bg-white rounded-xl shadow-sm p-3 border-l-4 flex items-center gap-3",
  style: {"border-left-color":"#4791FC"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-blue-50",
  style: {"color":"#4791FC"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar text-lg" })
], -1)
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-semibold",
  style: {"color":"#4791FC"}
}, "Total Jadwal", -1)
const _hoisted_6 = { class: "text-xs text-gray-500 mt-0.5" }
const _hoisted_7 = { class: "text-2xl font-bold text-gray-800 text-right" }
const _hoisted_8 = {
  class: "bg-white rounded-xl shadow-sm p-3 border-l-4 flex items-center gap-3",
  style: {"border-left-color":"#4CAF50"}
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-green-50\" style=\"color:#4CAF50;\"><i class=\"pi pi-check-circle text-lg\"></i></div><div class=\"min-w-0 flex-1\"><div class=\"text-sm font-semibold\" style=\"color:#4CAF50;\">Sudah Berangkat</div><div class=\"text-xs text-gray-500 mt-0.5\"> Total bus yang sudah berangkat </div></div>", 2)
const _hoisted_11 = { class: "text-2xl font-bold text-gray-800 text-right" }
const _hoisted_12 = {
  class: "bg-white rounded-xl shadow-sm p-3 border-l-4 flex items-center gap-3",
  style: {"border-left-color":"#FFA800"}
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-yellow-50\" style=\"color:#FFA800;\"><i class=\"pi pi-clock text-lg\"></i></div><div class=\"min-w-0 flex-1\"><div class=\"text-sm font-semibold\" style=\"color:#FFA800;\">Belum Berangkat</div><div class=\"text-xs text-gray-500 mt-0.5\"> Total bus yang belum berangkat </div></div>", 2)
const _hoisted_15 = { class: "text-2xl font-bold text-gray-800 text-right" }
const _hoisted_16 = {
  class: "bg-white rounded-xl shadow-sm p-3 border-l-4 flex items-center gap-3",
  style: {"border-left-color":"#F40023"}
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-red-50\" style=\"color:#F40023;\"><i class=\"pi pi-exclamation-triangle text-lg\"></i></div><div class=\"min-w-0 flex-1\"><div class=\"text-sm font-semibold\" style=\"color:#F40023;\">Terlewat</div><div class=\"text-xs text-gray-500 mt-0.5\"> Total bus yang tidak berangkat </div></div>", 2)
const _hoisted_19 = { class: "text-2xl font-bold text-gray-800 text-right" }

import { ref, onMounted, watch } from 'vue'
import moment from 'moment'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'RosterSummaryCards',
  props: {
  filterDate: {
    type: [Date, String],
    required: true
  }
},
  setup(__props) {

const props = __props



const summary = ref({
  TotalRosters: 0,
  DepartedRosters: 0,
  UpcomingRosters: 0,
  OverdueRosters: 0
})

const fetchDashboardRoster = async () => {
  try {
    const startDate = moment(props.filterDate).startOf('day').format('YYYY-MM-DD HH:mm:ss')
    const endDate = moment(props.filterDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    const response = await apiUseCase.get(`/roster/v2/Rosters/Dashboard?StartDate=${startDate}&EndDate=${endDate}`)
    if (!response.error && response.result) {
      summary.value = {
        TotalRosters: response.result.TotalRosters || 0,
        DepartedRosters: response.result.DepartedRosters || 0,
        UpcomingRosters: response.result.UpcomingRosters || 0,
        OverdueRosters: response.result.OverdueRosters || 0
      }
    }
  } catch (error) {
    console.error(error)
  }
}

watch(() => props.filterDate, () => {
  fetchDashboardRoster()
})

onMounted(() => {
  fetchDashboardRoster()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, " Total jadwal per " + _toDisplayString(_unref(moment)(__props.filterDate).format('DD MMM YYYY')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(summary.value.TotalRosters), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_11, _toDisplayString(summary.value.DepartedRosters), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_15, _toDisplayString(summary.value.UpcomingRosters), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_19, _toDisplayString(summary.value.OverdueRosters), 1)
    ])
  ]))
}
}

})